import { render, staticRenderFns } from "./PrintJournal.vue?vue&type=template&id=2a8800bc&scoped=true&"
import script from "./PrintJournal.vue?vue&type=script&lang=js&"
export * from "./PrintJournal.vue?vue&type=script&lang=js&"
import style0 from "./PrintJournal.vue?vue&type=style&index=0&id=2a8800bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8800bc",
  null
  
)

export default component.exports